// eslint-disable-next-line import/prefer-default-export
export const NOTIFY = 'NOTIFICATIONS_NOTIFY';
